// Settings-Typdefinition + Default-Werte.
// Dieses Schema ist die Single Source of Truth für UI + Stylesheet-Generator + JSON-Export.
// ----------------- Presets ----------------------------------------------------
const PAGE_PRESETS = {
    A5: { widthMm: 148, heightMm: 210 },
    B5: { widthMm: 176, heightMm: 250 },
    "6x9in": { widthMm: 152.4, heightMm: 228.6 },
    "5x8in": { widthMm: 127, heightMm: 203.2 },
    A4: { widthMm: 210, heightMm: 297 },
    custom: { widthMm: 148, heightMm: 210 },
};
export function pageDimensions(preset) {
    return PAGE_PRESETS[preset];
}
// ----------------- Defaults ---------------------------------------------------
export function defaultSettings() {
    return {
        version: 1,
        meta: {
            title: "Mein Buch",
            subtitle: "",
            author: "Unbekannt",
            language: "de",
        },
        page: {
            preset: "A5",
            widthMm: 148,
            heightMm: 210,
            marginTopMm: 18,
            marginBottomMm: 22,
            marginInnerMm: 22,
            marginOuterMm: 16,
            bleedMm: 0,
            cropMarks: false,
            spreadLayout: true,
            contentStartSide: "right",
        },
        typography: {
            bodyFontFamily: "EB Garamond",
            bodyFontUrl: "https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,600;1,400&display=swap",
            bodySizePt: 10.5,
            bodyLineHeight: 1.45,
            bodyAlignment: "justify",
            hyphenation: true,
            firstLineIndentEm: 1.2,
            paragraphSpacingEm: 0,
        },
        headings: {
            headingFontFamily: "Playfair Display",
            headingFontUrl: "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&display=swap",
            h1: {
                fontFamily: "Playfair Display",
                sizePt: 30,
                weight: 700,
                italic: false,
                uppercase: false,
                align: "left",
                lineHeight: 1.15,
                marginTopEm: 2,
                marginBottomEm: 1.5,
                letterSpacingEm: 0.01,
                pageBreakBefore: "right",
                color: "@text",
            },
            h2: {
                fontFamily: "Playfair Display",
                sizePt: 18,
                weight: 700,
                italic: false,
                uppercase: false,
                align: "left",
                lineHeight: 1.2,
                marginTopEm: 1.6,
                marginBottomEm: 0.6,
                letterSpacingEm: 0,
                pageBreakBefore: "none",
                color: "@text",
            },
            h3: {
                fontFamily: "Playfair Display",
                sizePt: 13,
                weight: 600,
                italic: false,
                uppercase: false,
                align: "left",
                lineHeight: 1.3,
                marginTopEm: 1.4,
                marginBottomEm: 0.3,
                letterSpacingEm: 0,
                pageBreakBefore: "none",
                color: "@text",
            },
            h4: {
                fontFamily: "Playfair Display",
                sizePt: 11,
                weight: 600,
                italic: true,
                uppercase: false,
                align: "left",
                lineHeight: 1.35,
                marginTopEm: 1.2,
                marginBottomEm: 0.2,
                letterSpacingEm: 0,
                pageBreakBefore: "none",
                color: "@text",
            },
        },
        blockquote: { italic: true, indentEm: 2, borderLeft: false },
        dropCap: {
            enabled: false,
            lines: 3,
            color: "#000000",
            fontFamily: "Playfair Display",
        },
        runningHeader: {
            enabled: true,
            versoLeft: "{book_title}",
            versoRight: "",
            rectoLeft: "",
            rectoRight: "{chapter_title}",
            hideOnChapterOpener: true,
            rule: "below",
        },
        runningFooter: {
            enabled: true,
            versoLeft: "",
            versoCenter: "{page_number}",
            versoRight: "",
            rectoLeft: "",
            rectoCenter: "{page_number}",
            rectoRight: "",
        },
        pageNumbers: { style: "arabic", hideOnChapterOpener: true, startAt: 1 },
        toc: { enabled: true, title: "Inhaltsverzeichnis", depth: 2, leader: "dots" },
        impressum: { enabled: false, body: "", logoAlign: "left", textAlign: "left", logoWidthMm: 28 },
        cover: {
            mode: "none",
            includeInPdf: true,
            bleedExtend: false,
            insideFront: { include: false },
            insideBack: { include: false },
            back: { include: false },
        },
        images: { defaultWidthPct: 100, captionItalic: true, captionAlign: "center" },
        widows: 2,
        orphans: 2,
        colors: { text: "#1a1a1a", accent: "#4a4a4a", muted: "#666666", custom: {} },
        smartQuotes: true,
        print: {
            enabled: false,
            iccProfile: "ISOcoated_v2_300_eci",
            pdfxVersion: "PDF/X-4",
            outputConditionIdentifier: "FOGRA39",
            outputCondition: "ISO Coated v2 (ECI)",
            renderingIntent: "RelativeColorimetric",
            keepLinks: false,
        },
    };
}
/** Tiefes Update: bekommt ein partielles Settings-Patch (verschachtelt) und merged. */
export function mergeSettings(base, patch) {
    if (!patch || typeof patch !== "object")
        return base;
    const out = Array.isArray(base) ? [...base] : { ...base };
    for (const k of Object.keys(patch)) {
        const v = patch[k];
        if (v && typeof v === "object" && !Array.isArray(v)) {
            out[k] = mergeSettings(base[k], v);
        }
        else if (v !== undefined) {
            out[k] = v;
        }
    }
    return out;
}
